import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import * as Ant from "antd";
import { Routes } from "@bundles/UIAppBundle";
import { useUIComponents, useRouter, useDataOne, use, useTranslate, } from "@bluelibs/x-ui";
import { ObjectId } from "@bluelibs/ejson";
import { BanksCollection } from "@bundles/UIAppBundle/collections";
import { BankViewer } from "../../config/BankViewer";
import { features } from "../../config/features";
import { useAppGuardian } from "@bundles/UIAppBundle/services/AppGuardian";
import { UserRole } from "@root/api.types";
export function BanksView(props) {
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const collection = use(BanksCollection);
    // If you want to benefit of live data features use useLiveData()
    const { data: document, isLoading, error, } = useDataOne(BanksCollection, new ObjectId(props.id), BankViewer.getRequestBody());
    let content;
    if (isLoading) {
        content = (_jsx(Ant.Space, Object.assign({ align: "center" }, { children: _jsx(Ant.Spin, { size: "large" }, void 0) }), void 0));
    }
    else {
        if (error || document === null) {
            content = (_jsx(Ant.Alert, { message: error || t("generics.error_message"), type: "error" }, void 0));
        }
        else {
            content = _jsx(BanksViewComponent, { document: document }, void 0);
        }
    }
    return (_jsx(UIComponents.AdminLayout, { children: _jsxs("div", Object.assign({ className: "bg-white" }, { children: [_jsx(Ant.PageHeader, { title: t("management.banks.view.header"), onBack: () => window.history.back(), extra: getHeaderActions(collection, router, props.id) }, void 0), _jsx(Ant.Card, { children: content }, void 0)] }), void 0) }, void 0));
}
export function BanksViewComponent(props) {
    const document = props.document;
    const viewer = use(BankViewer, { transient: true });
    viewer.setDocument(document);
    viewer.build();
    return (_jsx(Ant.Descriptions, Object.assign({ column: { xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 3 } }, { children: viewer.rest().map((item) => {
            return (_jsx(Ant.Descriptions.Item, Object.assign({ label: item.label }, { children: viewer.render(item) }), item.id));
        }) }), void 0));
}
export function getHeaderActions(collection, router, id) {
    var _a, _b;
    const actions = [];
    const t = useTranslate();
    const { state } = useAppGuardian();
    const hasAdminRole = ((_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : []).find((role) => [UserRole.ADMIN, UserRole.SHAREHOLDER].includes(role))
        ? true
        : false;
    if (features.edit && hasAdminRole) {
        actions.push(_jsx(Link, Object.assign({ to: router.path(Routes.BANKS_EDIT, {
                params: { id },
            }) }, { children: _jsx(Ant.Button, { children: t("generics.edit") }, void 0) }), "edit"));
    }
    if (features.delete && hasAdminRole) {
        actions.push(_jsx(Ant.Popconfirm, Object.assign({ title: t("management.banks.delete_question"), onConfirm: () => {
                collection.deleteOne(id).then(() => {
                    router.go(Routes.BANKS_LIST);
                    Ant.notification.success({
                        message: t("generics.success"),
                        description: t("management.banks.delete_confirmation"),
                    });
                });
            } }, { children: _jsx(Ant.Button, Object.assign({ className: "ant-btn-danger" }, { children: t("generics.delete") }), void 0) }), "delete"));
    }
    const viewRoutePath = router.path(Routes.BANKS_VIEW, {
        params: { id },
    });
    return actions;
}
